import { createRoot } from 'react-dom/client';
import './services/i18n';
import App from './modules/app';

export default function bootstrap(rootElement: HTMLElement) {
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  }
}
